import { useIntl } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { Gap } from 'ui-components/components/flex/gap';
import { FlexRow } from 'ui-components/components/flex/row';
import { Text } from 'ui-components/components/text/text';
import { TextType } from 'ui-components/components/text/text-type';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { RedoIcon } from './icons/redo-icon';
import { UndoIcon } from './icons/undo-icon';
import style from './undo-redo-buttons.module.less';
import { messages } from '../../messages';

type UndoRedoButtonsProps = {
  canUndo: boolean;
  canRedo: boolean;
  onUndo: () => void;
  onRedo: () => void;
  isDisabled?: boolean;
};

export const UndoRedoButtons = ({ canUndo, canRedo, onUndo, onRedo, isDisabled = false }: UndoRedoButtonsProps) => {
  const intl = useIntl();

  return (
    <FlexRow gap={Gap.Space8}>
      <Tooltip>
        <Button
          ariaLabel={intl.formatMessage(messages.undoButton)}
          className={style['icon-button']}
          disabled={isDisabled || !canUndo}
          onClick={onUndo}
          theme={THEME_CONSTANTS.white}
        >
          <UndoIcon />
        </Button>
        <TooltipContent>
          <Text textType={TextType.Caption} value={messages.undoButton} />
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <Button
          ariaLabel={intl.formatMessage(messages.redoButton)}
          className={style['icon-button']}
          disabled={isDisabled || !canRedo}
          onClick={onRedo}
          theme={THEME_CONSTANTS.white}
        >
          <RedoIcon />
        </Button>
        <TooltipContent>
          <Text textType={TextType.Caption} value={messages.redoButton} />
        </TooltipContent>
      </Tooltip>
    </FlexRow>
  );
};
